import styled from 'styled-components';
import {dFlexColumn, dFlexBetween} from '../../../globalVariables/GlobalFlex';

export const kvList = styled.dl`
    ${dFlexColumn}
    margin: 0;
    gap: var(--space-sm);
`;

export const kvRow = styled.div`
    ${dFlexBetween}
    gap: var(--space-sm);
    font-size: var(--font-size-body-small);
`;

export const kvLabel = styled.dt`
    color: var(--color-text-default);
`;

export const kvValue = styled.dd`
    margin: 0;
    font-weight: var(--font-weight-bold);

    &.discount {
        color: var(--primitive-green-600);
    }
`;

export const block = styled.div`
    ${dFlexColumn}
    gap: var(--space-xs);
`;

export const blockHeading = styled.h4`
    margin: 0;
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
`;

export const blockLine = styled.span`
    font-size: var(--font-size-body-small);
    color: var(--color-text-default);
`;
